import React, { Component } from 'react';
import '../css/formats.css';
import { Datos_Empresa, development } from "../libs/utils/Const";

class FormatTicketModal extends Component {

    render()  {
        
        return (
          
            <div>
                <div className="modal fade  modal-fullscreen" id="formatTicketModal" data-backdrop="static" data-keyboard="false" tabIndex="-1" aria-labelledby="formatTicketModalLabel" aria-hidden="true" >
                    <div className="modal-dialog" >
                        <div className="modal-content">
                        <div className="modal-header" style={{background: "#343a40"}}>
                            <img src={require('../images/logocounter.png')} className="image" alt="COUNTER ONE" />
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close" style={{color: "white"}}>
                            <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className='row'>
                                <div className='col-2'></div>
                                <div className='col-4'>
                                    <div className='mt-5' style={{width:"322px", height:"auto", marginLeft: "auto", marginRight:"auto", border: "solid 1px"}}>
                                        <div className='row p-3'>
                                            <div className='col-12 text-center'>
                                                <span><strong>NOTA CAJA</strong></span>
                                            </div>
                                        </div>
                                        <div className='row p-3'>
                                            <div className="col-12 text-center text-ticket">
                                                <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo" style={{maxWidth:"170px"}}/>
                                                <p><strong>{Datos_Empresa.Nombre}<br/>{Datos_Empresa.Sociedad}<br/>{Datos_Empresa.RFC}</strong></p>                                        
                                                <p >COL. C.P.;,.</p>
                                                <span >Tel. Cel.</span>
                                            </div>
                                        </div>
                                        <div className='row p-3'>
                                            <div className='col-12 text-ticket '>
                                                <table>
                                                    <tbody style={{borderTop: "solid 2px", borderBottom: "solid 2px"}}>
                                                        <tr>
                                                            <td>FOLIO: </td>
                                                            <td className='text-right'>A00A0CCA4647</td>
                                                        </tr>
                                                        <tr>
                                                            <td>FECHA: </td>
                                                            <td className='text-right'>15/08/2022 01:14 PM</td>
                                                        </tr>
                                                        <br/>
                                                        <tr>
                                                            <td>Doc. de origen: </td>
                                                            <td className='text-right'></td>
                                                        </tr>
                                                        <tr>
                                                            <td>RÉGIMEN FISCAL:</td>
                                                            <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Asesor/a de ventas: </td>
                                                            <td className='text-right'>VENTA DE PISO MATRIZ</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cajero/a: </td>
                                                            <td className='text-right'>5,125</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> 
                                        <div className='row pl-3 pr-3'>
                                            <div className='col-12 text-ticket '>
                                                <div className='text-center pb-3'>
                                                    <span><strong>DATOS DEL CLIENTE</strong></span>
                                                </div>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>NOMBRE: </td>
                                                            <td className='text-right'>VENTA DE MOSTRADOR</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CLAVE: CA001</td>
                                                            <td className='text-right'>RUT: XAXX010101000</td>
                                                        </tr>
                                                        <tr>
                                                            <td>TELÉFONO: </td>
                                                            <td className='text-right'></td>
                                                        </tr>
                                                        <tr>
                                                            <td>RÉGIMEN FISCAL:</td>
                                                            <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br/>
                                                <span>Dirección de Fiscal:</span>
                                                <p>
                                                    No.  Col.  C.P , ,
                                                </p>
                                                <span>Dirección de entrega:</span>
                                                <p>
                                                    {Datos_Empresa.Calle} #{Datos_Empresa.Numero} COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='row pl-3 pr-3'>
                                            <div className='col-12 text-ticket '>
                                                <div>
                                                    <span>MONEDA: SOL</span>
                                                </div>
                                                <table>
                                                    <thead style={{borderBottom: "solid 2px"}}>
                                                        <tr>
                                                            <th>Código</th>
                                                            <th className='text-right'>Cant.</th>
                                                            <th className='text-right'>UM</th>
                                                            <th className='text-right'>Precio</th>
                                                            <th className='text-right'>Importe</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="5">CEMENTO GRIS DE 50 KGS</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CEMENTO</td>
                                                            <td className='text-right'>3</td>
                                                            <td className='text-right'>XSA</td>
                                                            <td className='text-right'>251.34</td>
                                                            <td className='text-right'>$291.55</td>
                                                        </tr>
                                                        <br/> 
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>SUB TOTAL</strong></td>
                                                            <td className='text-right' colspan="2"><strong>251.34</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>IVA</strong></td>
                                                            <td className='text-right' colspan="2"><strong>40.21</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>TOTAL</strong></td>
                                                            <td className='text-right' colspan="2"><strong>291.55</strong></td>
                                                        </tr>
                                                        <br/> 
                                                        <tr>
                                                            <td colspan="5">DOSCIENTOS NOVENTA Y UN SOLES 55/100 M.N</td>
                                                        </tr>                                             
                                                    </tbody>
                                                </table>
                                                <br/> 
                                                <p>Comentarios: Basado en venta de Counter One<br/>A00A0CCA4647</p> 
                                            </div>
                                        </div>
                                        <div className='row pl-4 pr-4'>
                                            <div className='text-center text-ticket-xs'>
                                                <p>
                                                Sin más por el momento y en espera de vernos favorecidos,
                                                quedo de Usted para cualquier duda o aclaración.
                                                * Precios Sujetos a Cambio Sin Previo Aviso.
                                                ** Los precios arriba cotizados son para los volúmenes 
                                                solicitados, por lo que al variar estos los precios pueden verse
                                                afectados.<br/>
                                                *** Maniobras de descarga a cargo del cliente.
                                                Toda cancelación o devolución sólo será efectiva presentando 
                                                la nota y en un plazo no mayor a 7 días.
                                                Si se requiere factura, es en un plazo no mayor a 7 días, y/o
                                                en los casos que aplique, antes de cierre de mes.
                                                </p><br/><br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='col-4'>
                                    <div className='mt-5' style={{width:"230px", height:"auto", marginLeft: "auto", marginRight:"auto", border: "solid 1px"}}>
                                        <div className='row p-3'>
                                            <div className='col-12 text-center'>
                                                <span><strong>NOTA CAJA</strong></span>
                                            </div>
                                        </div>
                                        <div className='row p-3'>
                                            <div className="col-12 text-center text-ticket2">
                                                <img src={development? require('../images/logo_draft.svg') : require('../images/logo_EMPRESA.svg')} alt="Logo" style={{maxWidth:"170px"}}/>
                                                <p><strong>{Datos_Empresa.Nombre}<br/>{Datos_Empresa.Sociedad}<br/>{Datos_Empresa.RFC}</strong></p>                                        
                                                <p >COL. C.P.;,.</p>
                                                <span >Tel. Cel.</span>
                                            </div>
                                        </div>
                                        <div className='row p-3'>
                                            <div className='col-12 text-ticket2'>
                                                <table>
                                                    <tbody style={{borderTop: "solid 2px", borderBottom: "solid 2px"}}>
                                                        <tr>
                                                            <td>FOLIO: </td>
                                                            <td className='text-right'>A00A0CCA4647</td>
                                                        </tr>
                                                        <tr>
                                                            <td>FECHA: </td>
                                                            <td className='text-right'>15/08/2022 01:14 PM</td>
                                                        </tr>
                                                        <br/>
                                                        <tr>
                                                            <td>Doc. de origen: </td>
                                                            <td className='text-right'></td>
                                                        </tr>
                                                        <tr>
                                                            <td>RÉGIMEN FISCAL:</td>
                                                            <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Asesor/a de ventas: </td>
                                                            <td className='text-right'>VENTA DE PISO MATRIZ</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Cajero/a: </td>
                                                            <td className='text-right'>5,125</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div> 
                                        <div className='row pl-3 pr-3'>
                                            <div className='col-12 text-ticket2'>
                                                <div className='text-center pb-3'>
                                                    <span><strong>DATOS DEL CLIENTE</strong></span>
                                                </div>
                                                <table>
                                                    <tbody>
                                                        <tr>
                                                            <td>NOMBRE: </td>
                                                            <td className='text-right'>VENTA DE MOSTRADOR</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CLAVE: CA001</td>
                                                            <td className='text-right'>RUT: XAXX010101000</td>
                                                        </tr>
                                                        <tr>
                                                            <td>TELÉFONO: </td>
                                                            <td className='text-right'></td>
                                                        </tr>
                                                        <tr>
                                                            <td>RÉGIMEN FISCAL:</td>
                                                            <td className='text-right'>PERSONA FÍSICA CON ACTIVIDAD EMPRESARIAL</td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                                <br/>
                                                <span>Dirección de Fiscal:</span>
                                                <p>
                                                    No.  Col.  C.P , ,
                                                </p>
                                                <span>Dirección de entrega:</span>
                                                <p>
                                                    COL. {Datos_Empresa.Colonia},{Datos_Empresa.Ciudad}, {Datos_Empresa.Estado}. C.P.{Datos_Empresa.CP}
                                                </p>
                                            </div>
                                        </div>
                                        <div className='row pl-3 pr-3'>
                                            <div className='col-12 text-ticket2'>
                                                <div>
                                                    <span>MONEDA: SOL</span>
                                                </div>
                                                <table>
                                                    <thead style={{borderBottom: "solid 2px"}}>
                                                        <tr>
                                                            <th>Código</th>
                                                            <th className='text-right'>Cant.</th>
                                                            <th className='text-right'>UM</th>
                                                            <th className='text-right'>Precio</th>
                                                            <th className='text-right'>Importe</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <td colspan="5">CEMENTO GRIS DE 50 KGS</td>
                                                        </tr>
                                                        <tr>
                                                            <td>CEMENTO</td>
                                                            <td className='text-right'>3</td>
                                                            <td className='text-right'>XSA</td>
                                                            <td className='text-right'>251.34</td>
                                                            <td className='text-right'>$291.55</td>
                                                        </tr>
                                                        <br/> 
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>SUB TOTAL</strong></td>
                                                            <td className='text-right' colspan="2"><strong>251.34</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>IVA</strong></td>
                                                            <td className='text-right' colspan="2"><strong>40.21</strong></td>
                                                        </tr>
                                                        <tr>
                                                            <td colspan="1"></td>
                                                            <td colspan="2"><strong>TOTAL</strong></td>
                                                            <td className='text-right' colspan="2"><strong>291.55</strong></td>
                                                        </tr>
                                                        <br/> 
                                                        <tr>
                                                            <td colspan="5">DOSCIENTOS NOVENTA Y UN SOLES 55/100 M.N</td>
                                                        </tr>                                             
                                                    </tbody>
                                                </table>
                                                <br/> 
                                                <p>Comentarios: <br/>Basado en venta de Counter One<br/>A00A0CCA4647</p> 
                                            </div>
                                        </div>
                                        <div className='row pl-4 pr-4'>
                                            <div className='text-center text-ticket2-xs'>
                                                <p>
                                                Sin más por el momento y en espera de vernos favorecidos,
                                                quedo de Usted para cualquier duda o aclaración.
                                                * Precios Sujetos a Cambio Sin Previo Aviso.
                                                ** Los precios arriba cotizados son para los volúmenes 
                                                solicitados, por lo que al variar estos los precios pueden verse
                                                afectados.<br/>
                                                *** Maniobras de descarga a cargo del cliente.
                                                Toda cancelación o devolución sólo será efectiva presentando 
                                                la nota y en un plazo no mayor a 7 días.
                                                Si se requiere factura, es en un plazo no mayor a 7 días, y/o
                                                en los casos que aplique, antes de cierre de mes.
                                                </p><br/><br/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <button type="button" className="btn btn-secondary" data-dismiss="modal">Cerrar</button>
                            
                        </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default FormatTicketModal;